import { GROUP_BY_HEADER_LABELS } from '../constants/default';

export const getGroupByHeaderLabel = (id) => {
	const sliced = id.split('(');
	const label = GROUP_BY_HEADER_LABELS[sliced[0].trim()];

	if (!label) {
		return id;
	}

	return `${label} (${sliced[1]}`;
};
